import { Box, Card, Divider, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import { Link } from "react-router-dom";
import PrimarySmallBlueButton from "../../../components/customButtons/PrimarySmallBlueButton";
import DisableBlueSmallButton from "../../../components/customButtons/DisableSmallBlueButton";

export default function PackageSummry({
  classData,
  packageData,
  onSubmit,
  proceesLoading,
}) {
  return (
    <>
      <GlobalCard height="100%">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              textAlign="start"
              color="#572575"
              fontFamily="Inter"
              fontSize="20px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
              Order Summary
            </Typography>
          </Grid>

          <Grid item xs={12} mt={1}>
            <Card
              sx={{
                background: "#F9F7FF",
                border: "0.5px solid #FFE2FA",
                padding: "10px",
                borderRadius: "8px",
              }}
            >
              <Grid container spacing={1.5}>
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  alignItems="center"
                  gap={1}
                  mb={1}
                >
                  <Box width={24} height={24}>
                    <img src="/newdashboard/Checkout/mdi_gift.png" />
                  </Box>
                  <Typography
                    textAlign="start"
                    color="#572575"
                    fontFamily="Inter"
                    fontSize="17px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 400 }}
                  >
                    Package & Class Details
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    textAlign="start"
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 400 }}
                  >
                    class :{" "}
                    <span style={{ color: "#9D0385", fontWeight: 600 }}>
                      {classData?.name}
                    </span>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    textAlign="start"
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 400 }}
                  >
                    Package :{" "}
                    <span style={{ color: "#9D0385", fontWeight: 600 }}>
                      {packageData?.package_name}
                    </span>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    textAlign="start"
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 400 }}
                  >
                    Duration :{" "}
                    <span style={{ color: "#9D0385", fontWeight: 600 }}>
                      {packageData?.duration} days
                    </span>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    textAlign="start"
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 400 }}
                  >
                    Time Slot :{" "}
                    <span style={{ color: "#9D0385", fontWeight: 600 }}>
                      {classData?.start_time} {classData?.end_time}
                    </span>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    textAlign="start"
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 400 }}
                  >
                    Delivery Mode :{" "}
                    <span style={{ color: "#9D0385", fontWeight: 600 }}>
                      {classData?.mode_of_delivery}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item xs={12} mt={1}>
            <Stack spacing={2}>
              {/* Original Price */}
              <Box display="flex" justifyContent="space-between">
                <Typography
                  textAlign="start"
                  color="#555555"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0px"
                  fontStyle="normal"
                  style={{ fontWeight: 400 }}
                >
                  Original Price
                </Typography>
                <Typography
                  textAlign="start"
                  color="#222222"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0px"
                  fontStyle="normal"
                  style={{ fontWeight: 400 }}
                >
                  {packageData?.currency} {packageData?.original_price}
                </Typography>
              </Box>
              <Divider />

              {/* Discount */}
              {/* <Box display="flex" justifyContent="space-between">
                    <Typography textAlign="start"
                      color="#555555"
                      fontFamily="Inter"
                      fontSize="14px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}>Discount</Typography>
                    <Typography textAlign="start"
                      color="#222222"
                      fontFamily="Inter"
                      fontSize="14px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}>$ 0.00</Typography>
                  </Box>

                  <Divider /> */}

              {/* Total */}
              <Box display="flex" justifyContent="space-between">
                <Typography
                  textAlign="start"
                  color="#572575"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0px"
                  fontStyle="normal"
                  style={{ fontWeight: "bold" }}
                >
                  Total{" "}
                  <span style={{ color: "#000000", fontWeight: 400 }}>
                    {" "}
                    (1 course)
                  </span>
                </Typography>
                <Typography
                  textAlign="start"
                  color="#572575"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0px"
                  fontStyle="normal"
                  style={{ fontWeight: "bold" }}
                >
                  {packageData?.currency} {packageData?.original_price}
                </Typography>
              </Box>

              <Divider />

              {/* Terms and Policies */}
              <Typography
                textAlign="start"
                color="#777777"
                fontFamily="Inter"
                fontSize="13px"
                lineHeight="1x"
                letterSpacing="0px"
                fontStyle="normal"
                style={{ fontWeight: 400 }}
              >
                By completing your purchase, you acknowledge that you have read
                and agree to our{" "}
                <a
                  href="/termsAndConditions"
                  underline="hover"
                  style={{ color: "#572575" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Use and Privacy Policy.
                </a>{" "}
              </Typography>
            </Stack>
          </Grid>

          {packageData?.original_price === 0 ? (
            <DisableBlueSmallButton />
          ) : (
            <Grid item xs={12} mt={2}>
              <PrimarySmallBlueButton
                onClick={onSubmit}
                startIcon={
                  <img src="/newdashboard/Checkout/material-symbols-light_lock.png" />
                }
                buttonTitle={
                  proceesLoading ? "Processing..." : "Proceed To pay"
                }
                width="100%"
              />
            </Grid>
          )}
        </Grid>
      </GlobalCard>
    </>
  );
}
